import React, { useEffect } from 'react';
import './styles/ResumeSectionDesktop.css';
import './styles/ResumeSectionMobile.css';
import { animateResumeEntries, attachResumeMouseTracking } from './AnimateResumeEntries.js';


function UnitedStatesResume() {
  useEffect(() => {
    const resumeEntries = document.querySelectorAll("div.resumeentry");
    animateResumeEntries(resumeEntries);

    const onScroll = () => animateResumeEntries(resumeEntries);
    document.addEventListener('scroll', onScroll);
    const detachMouse = attachResumeMouseTracking(resumeEntries);

    return () => {
        document.removeEventListener('scroll', onScroll);
        detachMouse();
    };
    }, []);


  return (
    <div>
    <div className="resumeentry current animateddiv">
        <div className="current-badge"><span className="pulse"></span>CURRENT</div>
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/certivlogonew.svg').default} alt="Certiv logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1><a href="https://certiv.ai" target="_blank" rel="noopener noreferrer">Certiv.ai</a> <span className="title-divider">|</span> Co-Founder &amp; Chief AI Officer</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/project.png')} alt="Project"/></div>
            </div>

            <div className="resumeentrydate">
                <p>May 2025 — Current</p>
            </div>

            <div className="resumeentrytext">
                <p>Co-founder and Chief AI Officer at Certiv, an agent runtime security startup backed by $4M in funding. Leading the development of ML infrastructure to secure the next generation of AI agents.</p>
                <ul>
                    <li>Building and managing ML Ops infrastructure for training and deploying state-of-the-art security models at scale</li>
                    <li>Fine-tuning large language models for real-time intent detection and policy violation identification in agent workflows</li>
                    <li>Developing novel approaches to secure agent runtimes, ensuring AI systems operate safely within defined boundaries</li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/atrieonxpsl.png')} alt="Atrieon x PSL logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1><a href="https://atrieon.ai" target="_blank" rel="noopener noreferrer">Atrieon.ai</a> <span className="title-divider">|</span> Acting CTO <span className="title-divider">|</span> <a href="https://psl.com" target="_blank" rel="noopener noreferrer">Pioneer Square Labs</a> <span className="title-divider">|</span> Folded into <a href="https://empwr.ai" target="_blank" rel="noopener noreferrer">EMPWR.ai</a></h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/project.png')} alt="Project"/></div>
            </div>

            <div className="resumeentrydate">
                <p>March 2024 — May 2025</p>
            </div>

            <div className="resumeentrytext">
                <p>As co-founder and acting CTO of Atrieon at PSL, I've pioneered a revolutionary agentic orchestration platform that transforms how organizations manage complex projects, workflows and teams of AI Agents. Built to manage Agents from the ground up, Atrieon leverages cutting-edge AI to autonomously coordinate tasks, resources, and teams with unprecedented efficiency.</p>
                <ul>
                    <li>Architected and implemented a first-of-its-kind agentic framework capable of understanding, planning, and executing multi-stage projects with minimal human intervention</li>
                    <li>Developed proprietary orchestration algorithms that dynamically adapt to changing project requirements and resource constraints in real-time</li>
                    <li>Created an innovative agent collaboration system where specialized AI agents work together to solve complex problems while maintaining alignment with human objectives</li>
                    <li>Designed a natural language interface that allows non-technical stakeholders to define, monitor, and modify project parameters through conversational interactions</li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/microsoftxresearch.png')} alt="Microsoft Research logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>Software Engineer &amp; Tech Lead <span className="title-divider">|</span> Program Synthesis Research &amp; Engineering</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/work.png')} alt="Work"/></div>
            </div>

            <div className="resumeentrydate">
                <p>May 2020 — May 2024</p>
            </div>

            <div className="resumeentrytext">
                <p>My work on the PROSE team represents the culimation of my dream to advance the state of the art
                    in artificial intelligence. Throughout the years I have been exposed to the intricacies of the research methodology
                    alongside cutting edge artificial intelligence techniques, and have worked alongside some of the best researchers in the world.
                </p>
                <ul>
                    <li>Selected to assess the capacity and ability of OpenAI's GPT-3, Codex and ChatGPT. Developed benchmarks and
                        evaluation techniques, appropriate domains of application and future areas of research.
                    </li>
                    <li>Prototyped several early-stage LLM-based developer tools in VsCode with a reciprocal research relationship with
                        GitHub Copilot.</li>
                    <li>Created and deployed a VsCode extension to extract key developer information to power a "repeated-edits"
                        framework for code repair, which was deployed in universities across three countries. </li>
                    <li>Built a containerised web application named "AITutor" to combine code repair technology, execution
                        infrastructure, and real-time hints to scaffold learning in University of Michigan's Online Data Science Class. <a href="https://www.coursera.org/learn/python-data-analysis" target="_blank" rel="noopener noreferrer">[1]</a></li>
                    <li>Created three new Data Extraction experiences utilising the Program Synthesis SDK into Microsoft
                        PowerQuery Desktop (.NET) and Web (ReactJs). These experiences are utilised by approximately 100,000 users
                        daily.&nbsp;
                        <a href="https://learn.microsoft.com/en-us/power-query/connectors/web/web-by-example" target="_blank" rel="noopener noreferrer">[2]</a>
                        <a href="https://support.microsoft.com/en-us/office/add-a-column-from-an-example-power-query-cd82c570-8da7-4d70-91a1-3827b5995eab" target="_blank" rel="noopener noreferrer">[3]</a>
                        <a href="https://learn.microsoft.com/en-us/power-query/connectors/text-csv#textcsv-by-example" target="_blank" rel="noopener noreferrer">[4]</a></li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/covidwa1.png')} alt="CovidWA logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>Co-Founder <span className="title-divider">|</span> Scraper Tech <span className="title-divider">|</span> <a href="https://www.covidwa.com/news/" target="_blank" rel="noopener noreferrer">Covidwa.com News &amp; Testimonials</a></h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/philanthropy.png')} alt="Philanthropy"/></div>
            </div>

            <div className="resumeprojectwinner">
                <div className="resumeemoji">🥇 Winner — GeekWire "Geeks Who Give Back" Award 2022 🥇</div>
            </div>

            <div className="resumeentrytext">
                <p>The COVIDWA.com project began 7 days after I'd moved to the United States to help people find appointments for COVID-19 vaccines. The senior citizens of Washington had been thrown into a free-for-all,
                expected to search thousands of websites individually for rapidly-closing appointments. We<b> automated </b>this process helping over 1,000,000 people directly and an additional 2,500,000 through our API.
                A few learnings from this project are called out below:
                </p>
                <ul>
                    <li> There are limits to how fast you can scale an organisation. Eventually, an extra person leads to more overhead than impact.
                    </li>
                    <li> Despite your intentions being good, your success can contrast the failure of powerful people. The CovidWa project was built by volunteers, and scaled to support millions
                        in weeks. Powerful companies had been paid $40+ million dollars with year timeframes and failed to deliver.
                    </li>
                    <li>
                         The media loves a feel-good story.
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/microsoftlogo.png')} alt="Microsoft logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1> Engineer <span className="title-divider">|</span> Azure Synapse <span className="title-divider">|</span> Microsoft</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/work.png')} alt="Work"/></div>
            </div>

            <div className="resumeentrydate">
                <p>May 2024 — September 2025</p>
            </div>

            <div className="resumeentrytext">
                <p>Leveraging my extensive startup experience, I'm driving innovation within Microsoft's Azure Synapse team, focusing on enterprise-scale machine learning solutions that mirror the agility and performance demands of high-growth startups.</p>
                <ul>
                    <li>Architected scalable ML pipeline solutions capable of handling petabyte-scale data processing with startup-like efficiency</li>
                    <li>Led the development of new Synapse features that reduce time-to-insight for data scientists by over 40%</li>
                    <li>Implemented distributed training frameworks that enable ML models to scale horizontally across thousands of nodes</li>
                </ul>
            </div>
        </div>
    </div>

    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/aitutor.png')} alt="AITutor logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>AITutor <span className="title-divider">|</span> Tech Lead <span className="title-divider">|</span> <a href="https://www.microsoft.com/en-us/research/project/ai-for-programming-education/" target="_blank" rel="noopener noreferrer">Microsoft Research</a></h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/project.png')} alt="Project"/></div>
            </div>

            <div className="resumeprojectwinner">
                <div className="resumeemoji">🥇 Winner — Microsoft CTO Codex Challenge 2022 🥇</div>
            </div>
            <div className="resumeentrytext">
                <p>The AI-Tutor project combined the power of modern Large-Language Models and Program Synthesis technology with verification via assignment unit-tests.
                    Using a combination of code repair providers, the project repairs the student's code, finds an explaination for the repair, and then turns that explaination
                    into a "hint" rather than a direct guideline in line with supporting pedagogy.
                </p>
                <ul>
                    <li> Built using Containerised infrastructure, able to verify 100's of candidate fixes and return in seconds
                    </li>
                    <li> Easily integrated into VsCode and Juypter via simple client side API's
                    </li>
                    <li> Deployed in real-world courses in a number of top colleges in the United States
                    </li>
                </ul>
            </div>
        </div>
    </div>


    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/fixie.png')} alt="Fixie logo"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>Email Assistant <span className="title-divider">|</span> Team Lead <span className="title-divider">|</span> <a href="https://twitter.com/juberti/status/1634735034296070145?s=20" target="_blank" rel="noopener noreferrer">Fixie Hackathon</a></h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/project.png')} alt="Project"/></div>
            </div>

            <div className="resumeprojectwinner">
                <div className="resumeemoji">🥇 Winner — Fixie Inaugural Hackathon 2023 🥇</div>
            </div>
            <div className="resumeentrytext">
                <p>In an effort to reduce the load that emails put on a C-Suite employee, the email assistant reads and creates draft replies for all incoming emails for a GMail account.
                    The user can then accept, edit, or decline to reply with any of the drafts. The user can also add configuration parameters such as "I'm very busy today" which will modify
                    the draft emails accordingly.
                </p>
            </div>
        </div>
    </div>


    <div className="resumeentry animateddiv">
        <div className="resumeentryimagecontainer">
            <img className="resumeentryimage" src={require('./assets/research.png')} alt="Research"/>
        </div>

        <div className="resumetextcontainer">
            <div className="resumetextheader">
                <div className="resumeentrytitle">
                    <h1>Multi-modal program inference: a marriage of pre-trained language models and component-based synthesis</h1>
                </div>
                <div className="resumeentryimagetypecontainer"><img className="resumeentryimagetypeemoji" src={require('./assets/researchpaper.png')} alt="Research paper"/></div>
            </div>

            <div className="resumeprojectwinner">
                📖 <a href="https://dl.acm.org/doi/abs/10.1145/3485535?sid=SCITRUS" target="_blank" rel="noopener noreferrer">OOPSLA 2021</a> 📖
            </div>
            <div className="resumeentrytext">
                    <p> Multi-modal program synthesis refers to the task of synthesizing programs (code) from their specification given in different forms,
                        such as a combination of natural language and examples.
                        Examples provide a precise but incomplete specification, and natural language provides an ambiguous but more "complete" task description.
                    </p>
            </div>
        </div>
    </div>


    </div>
  );
}

export default UnitedStatesResume;
